import { initFancybox } from "../fancybox.ts";

import "./review-widget/reviewScore.css";
import "./review.css";

function initReview() {
  void initFancybox();
}

export { initReview };
